import { Routes, Route } from "react-router-dom";
import AdminDashboard from "../pages/Admin/Home";
import Users from "../pages/Admin/Users/Users";
import ViewUser from "../pages/Admin/Users/ViewUser";
import EditUser from "../pages/Admin/Users/EditUser";

import Music from "../pages/Admin/Music/Music";
import ViewMusic from "../pages/Admin/Music/ViewMusic";
import EditMusic from "../pages/Admin/Music/EditMusic";

import Transactions from "../pages/Admin/Transactions/Transactions";
import ViewTransaction from "../pages/Admin/Transactions/ViewTransaction";

import Plans from "../pages/Admin/Plans/Plans";
import AddPlan from "../pages/Admin/Plans/AddPlan";

import Royalties from "../pages/Admin/Royalties/Royalties";

import Admin from "../pages/Admin/AdminDashboard";
import NotFoundPage from "../pages/404";
const Router = () => {
  return (
    <Admin>
      <Routes>
        <Route index element={<AdminDashboard />} />
        <Route path="transactions/:subCat" element={<Transactions />} />
        <Route path="plans" element={<Plans />} />
        
        <Route path="users/:subCat" element={<Users />} />
        <Route path="users/:subCat/edit-user/:id" element={<EditUser />} />
        <Route path="users/:subCat/view-user/:id" element={<ViewUser />} />

      
        <Route path="music/:subCat" element={<Music />} />
        <Route path="music/:subCat/edit-music/:id" element={<EditMusic />} />
        <Route path="music/:subCat/view-music/:id" element={<ViewMusic />} />
        
        <Route path="transactions/:subCat" element={<Transactions />} />
        <Route path="transactions/:subCat/view-transaction/:id" element={<ViewTransaction />} />

        <Route path="royalties/all" element={<Royalties />} />

        <Route path="plans" element={<Plans />} />
        <Route path="plans/edit-plan/:id" element={<AddPlan />} />
        <Route path="plans/view-plan/:id" element={<AddPlan />} />
        <Route path="plans/add/new" element={<AddPlan />} />

        <Route path="*" Component={NotFoundPage} />
      </Routes>
    </Admin>
  );
};

export default Router;
